import { render, staticRenderFns } from "./filtrosGeneral.vue?vue&type=template&id=51b86dca&scoped=true&"
import script from "./filtrosGeneral.vue?vue&type=script&lang=js&"
export * from "./filtrosGeneral.vue?vue&type=script&lang=js&"
import style0 from "./filtrosGeneral.vue?vue&type=style&index=0&id=51b86dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b86dca",
  null
  
)

export default component.exports